/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import PropTypes from 'prop-types';

import { ComponentPropShape } from 'app/common/constants/CommonProps';

export default {
  components: PropTypes.shape({
    Form: PropTypes.func,
    HeaderActionComponents: PropTypes.func,
    actionComponents: PropTypes.shape({
      CreateAccount: PropTypes.func,
      FinishAccount: PropTypes.func,
      UpdateAccount: PropTypes.func
    })
  }),
  initialState: PropTypes.object,
  metadata: ComponentPropShape,
  reducer: PropTypes.func
};
